<template>
  <div>
    <Form :model="searchCondition" :label-width="70" inline>
      <FormItem label="活动状态">
        <EnumSelect
          type="GroupBookingStatus"
          selector="select"
          v-model="searchCondition.status"
          style="width:200px;"
          clearable
        ></EnumSelect>
      </FormItem>
      <FormItem label="商品类型">
        <EnumSelect
          type="ShopType"
          selector="select"
          v-model="searchCondition.product_type"
          style="width:200px;"
          clearable
          :except="['3', '4','9','13','14']"
        ></EnumSelect>
      </FormItem>
      <FormItem label="拼团名称">
        <Input
          v-model="searchCondition.spell_name"
          placeholder="请输入拼团名称关键字"
          style="width:200px;"
          clearable
          @keydown.native.prevent.enter="getList(false)"
        ></Input>
      </FormItem>
      <Form-item class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="getList(false)">搜索</Button>
          <Button icon="md-undo" @click="getList(true)">重置</Button>
        </div>
      </Form-item>
    </Form>
    <Button type="primary" :to="{name:'GroupBookingEdit',params:{new:1}}">新增拼团活动</Button>
    <div class="content">
      <Grid
        ref="grid"
        :columns="columns"
        data-url="/api/spellGroup/index"
        :search="searchCondition"
        :rowsFormatter="rowsFormatter"
        selectType="none"
        keyField="id"
        method="post"
      >
        <template slot-scope="{ row }" slot="c1">
          <span class="sp-num">{{row.user_num}}人团</span>
          <span>{{' '+row.spell_name}}</span>
        </template>
        <template slot-scope="{ row }" slot="action">
          <Button type="text" size="small" @click="promoteGroup(row)" v-if="row.status!=3">立即推广-</Button>
          <Button
            type="text"
            size="small"
            :to="{name: 'GroupBookingDetail',query:{id:row.id}}"
            v-if="row.status!=2"
          >查看-</Button>
          <Button
            type="text"
            size="small"
            :to="{name: 'GroupBookingEdit',query:{id:row.id},params:{new:1}}"
            v-if="row.status!=3"
          >编辑-</Button>
          <Button type="text" size="small" @click="stopGroup(row.id)" v-if="row.status!=3">终止活动</Button>
          <Button type="text" size="small" @click="deleteGroup(row.id)" v-if="row.status==3">删除</Button>
        </template>
      </Grid>
    </div>
    <Modal class="promote-modal" v-model="promote.showPromoteModal" title="活动推广" width="300px">
      <div class="promote">
        <div class="center">
          <img class="qrcode" :src="promote.img" />
          <div>
            <a href="javascript:void(0)" @click="download()">下载二维码立即推广</a>
          </div>
        </div>
        <div>
          <div class="title" style="margin-bottom:10px;">复制</div>
          <div>
            <input
              id="promote_url"
              :value="promote.url"
              style="outline:0;border:0;width:1px;color:white;"
            />
            <a class="link" href="javascript:void(0)" @click="copyUrl">
              <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M902.8 122.4c-73.6-76.8-198.3-76.8-271.9 0l-112 115.2c-12.8 12.8-12.8 35.2 0 48 12.8 12.8 32 12.8 44.8 0l112-115.2c51.2-51.2 131.2-51.2 182.3 0s51.2 134.4 0 185.5L675.6 541.5c-51.2 51.2-131.2 51.2-182.3 0-12.8-12.8-32-12.8-44.8 0-12.8 12.8-12.8 35.2 0 48 73.6 76.8 198.3 76.8 271.9 0L902.7 404c76.8-80 76.8-204.8 0.1-281.6zM461.3 739.8L349.4 855c-51.2 51.2-131.2 51.2-182.3 0-51.2-51.2-51.2-134.4 0-185.5L349.4 484c51.2-51.2 131.2-51.2 182.3 0 12.8 12.8 32 12.8 44.8 0 12.8-12.8 12.8-35.2 0-48-73.6-76.8-198.3-76.8-271.9 0L122.2 621.5c-76.8 76.8-73.6 201.5 0 278.3s198.3 76.8 271.9 0l112-115.2c12.8-12.8 12.8-35.2 0-48-12.8-9.6-32-9.6-44.8 3.2z"
                  p-id="1941"
                />
              </svg>
              <span>活动推广链接</span>
            </a>
          </div>
        </div>
      </div>
      <template v-slot:footer>
        <div></div>
      </template>
    </Modal>
  </div>
</template>
<script>
import { GroupBookingStatus, ShopType } from "@/utils/enums.js";
export default {
  name: "GroupBookingManage",
  data() {
    return {
      searchCondition: {
        status: "",
        spell_name: "",
        product_type: ""
      },
      columns: [
        {
          title: "拼团名称",
          slot: "c1",
          minWidth: 250
        },
        {
          title: "参团商品",
          key: "shop_name",
          width: 250,
          align: "left"
        },
        {
          title: "有效期",
          key: "timeRange",
          width: 280,
          align: "center"
        },
        {
          title: "活动状态",
          key: "status_name",
          width: 100,
          align: "center"
        },
        {
          title: "成团订单数",
          key: "group_order_num_str",
          width: 130,
          align: "center",
          renderHeader: h => {
            return h("div", [
              h("span", "成团订单数"),
              h(
                "Tooltip",
                {
                  props: {
                    content: "买家在该拼团活动，所支付的拼团订单数"
                  }
                },
                [
                  h("i", {
                    attrs: { class: "ivu-icon ivu-icon-md-help-circle" }
                  })
                ]
              )
            ]);
          }
        },
        {
          title: "成团订单金额",
          key: "group_order_price_str",
          width: 130,
          align: "center",
          renderHeader: h => {
            return h("div", [
              h("span", "成团订单金额"),
              h(
                "Tooltip",
                {
                  props: {
                    content: "买家在该拼团活动，所支付的拼团订单金额"
                  }
                },
                [
                  h("i", {
                    attrs: { class: "ivu-icon ivu-icon-md-help-circle" }
                  })
                ]
              )
            ]);
          }
        },
        {
          title: "操作",
          slot: "action",
          width: 200,
          align: "left",
          fixed: "right"
        }
      ],
      promote: {
        showPromoteModal: false,
        url: "",
        img: ""
      }
    };
  },
  methods: {
    getList(reset) {
      if (reset) {
        this.searchCondition.spell_name = "";
        this.searchCondition.product_type = "";
        this.searchCondition.status = "";
      }
      this.$refs.grid.searchRefresh();
    },
    rowsFormatter(rows) {
      rows.forEach(row => {
        row.timeRange =
          this.$pub.timestampToTime(row.start_time) +
          "~" +
          this.$pub.timestampToTime(row.end_time);
        row.status_name = GroupBookingStatus.getValue(row.status);
        row.group_order_num_str = row.status != 2 ? row.group_order_num : "--";
        row.group_order_price_str =
          row.status != 2 ? "¥" + row.group_order_price / 100 : "--";
        if (row.type == 2) {
          row.shop_name = "「图书」" + row.name;
        } else if (row.type == 1) {
          row.shop_name =
            "「" + ShopType.getValue(row.product_type) + "」" + row.title;
        }
      });
    },
    async deleteGroup(id) {
      await this.$promiseConfirm(
        "删除后，将无法查看该拼团活动相关数据，是否确认？",
        "提示",
        { type: "warning" }
      );
      await this.$http.delete("/api/spellGroup/del/" + id);
      this.$refs.grid.refresh();
    },
    async stopGroup(id) {
      await this.$promiseConfirm("终止活动后，如开启虚拟成团，则正在拼团中的团立即成团，反之正在拼团中的团，系统走退款流程；确定要终止该拼团活动吗？", "提示", {
        type: "warning"
      });
      await this.$http.put("/api/spellGroup/ending/" + id);
      this.$refs.grid.refresh();
    },
    async promoteGroup(row) {
      let data = await this.$http.get("/api/spellGroup/spread/" + row.id);
      this.promote.img = data.img_src;
      this.promote.url = data.url;
      this.promote.showPromoteModal = true;
    },
    copyUrl() {
      let ele = document.getElementById("promote_url");
      ele.select();
      document.execCommand("copy");
      this.$Message.success("复制成功");
    },
    download() {
      this.$pub.downloadFile(this.promote.img, "活动二维码.png");
    }
  }
};
</script>
<style lang="scss" scoped>
.sp-num {
  border: 1px solid #ccc;
}
.promote-modal {
  /deep/ {
    .ivu-modal-footer {
      display: none;
    }
  }
}
.promote {
  display: flex;
  > div:first-child {
    margin-right: 20px;
  }
  .qrcode {
    width: 140px;
    margin-bottom: 10px;
  }
  .link {
    svg {
      width: 12px;
      height: 12px;
      fill: $primary-color;
      font-size: 12px;
      margin-right: 4px;
    }
    svg,
    span {
      vertical-align: middle;
    }
  }
  .title::before {
    background-color: #ccc;
    width: 2px;
    height: 16px;
    top: 10px;
  }
}
#promote_url::selection {
  background-color: white;
}
</style>
